// File: C:\Users\s-naidu\Desktop\merchant-card\frontend\src\merchant\pages\forms\Form6StoreList.tsx

import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import MerchantLayout from "../../components/MerchantLayout";
import { apiGet, apiPut } from "../../api";



const API_BASE = "/api";

type StoreItem = {
  store_name: string;
  store_name_kana: string;
  store_postal: string;
  store_city: string;
  store_address: string;
  phone: string;
  fax: string;
  email: string;
};





type Form6 = {
  // Upload (別紙)
  store_list_file_name: string;
  store_list_file_selected: File | null;

  // Manual fields (first store mirror for backward compatibility)
  store_name: string;
  store_name_kana: string;

  store_postal: string;
  store_city: string;
  store_address: string;

  phone: string;
  fax: string;
  email: string;

  // New multi-store list
  store_items: StoreItem[];

  is_completed: boolean;
};

















const emptyStoreItem = (): StoreItem => ({
  store_name: "",
  store_name_kana: "",
  store_postal: "",
  store_city: "",
  store_address: "",
  phone: "",
  fax: "",
  email: "",
});











const empty: Form6 = {
  store_list_file_name: "",
  store_list_file_selected: null,

  store_name: "",
  store_name_kana: "",

  store_postal: "",
  store_city: "",
  store_address: "",

  phone: "",
  fax: "",
  email: "",

  store_items: [emptyStoreItem()],

  is_completed: false,
};








const normalizeStoreItem = (item?: Partial<StoreItem> | null): StoreItem => ({
  store_name: item?.store_name || "",
  store_name_kana: item?.store_name_kana || "",
  store_postal: item?.store_postal || "",
  store_city: item?.store_city || "",
  store_address: item?.store_address || "",
  phone: item?.phone || "",
  fax: item?.fax || "",
  email: item?.email || "",
});



const formatPhoneNumber = (value: string) => {
  const digits = value.replace(/\D/g, "").slice(0, 11);

  if (digits.length <= 3) return digits;

  if (digits.length <= 10) {
    if (digits.startsWith("03") || digits.startsWith("06")) {
      if (digits.length <= 6) return `${digits.slice(0, 2)}-${digits.slice(2)}`;
      return `${digits.slice(0, 2)}-${digits.slice(2, 6)}-${digits.slice(6)}`;
    }

    if (digits.length <= 5) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  }

  return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`;
};









export default function Form6StoreList() {
  const navigate = useNavigate();
  const fileRef = useRef<HTMLInputElement | null>(null);

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [data, setData] = useState<Form6>(empty);

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    const run = async () => {
      setError("");
      setSuccess("");

      try {
        const json = await apiGet("/merchant/forms/store-list");
        const d = json?.data;

                if (d) {
          const apiItems = Array.isArray(d.store_items) ? d.store_items : [];
          const normalizedItems =
            apiItems.length > 0
              ? apiItems.map((item: any) => normalizeStoreItem(item))
              : [
                  normalizeStoreItem({
                    store_name: d.store_name || "",
                    store_name_kana: d.store_name_kana || "",
                    store_postal: d.store_postal || "",
                    store_city: d.store_city || "",
                    store_address: d.store_address || "",
                    phone: d.phone || "",
                    fax: d.fax || "",
                    email: d.email || "",
                  }),
                ];

          const first = normalizedItems[0] || emptyStoreItem();

          setData({
            store_list_file_name: d.store_list_file_name || "",
            store_list_file_selected: null,

            store_name: first.store_name,
            store_name_kana: first.store_name_kana,

            store_postal: first.store_postal,
            store_city: first.store_city,
            store_address: first.store_address,

            phone: first.phone,
            fax: first.fax,
            email: first.email,

            store_items: normalizedItems,
            is_completed: Boolean(d.is_completed),
          });
        } else {
          setData(empty);
        }

        setLoading(false);
      } catch (e: any) {
        setError(
          e?.message ||
            "店舗一覧の取得に失敗しました。バックエンドが起動しているか、Form6のAPIが実装済みか確認してください。"
        );
        setLoading(false);
      }
    };

    run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const hasUploadedFile = !!data.store_list_file_selected || !!data.store_list_file_name;

  // ✅ Completion rule (BUSINESS LOGIC: keep as-is)
  // - If upload exists => can be completed even if manual fields empty
  // - If no upload => manual required fields must be filled
    const canComplete = useMemo(() => {
    if (hasUploadedFile) return true;

    if (!data.store_items.length) return false;

    return data.store_items.every(
      (item) =>
        item.store_name.trim() !== "" &&
        item.store_name_kana.trim() !== "" &&
        item.store_postal.trim() !== "" &&
        item.store_city.trim() !== "" &&
        item.store_address.trim() !== "" &&
        item.phone.trim() !== "" &&
        item.email.trim() !== ""
    );
  }, [hasUploadedFile, data.store_items]);

  // ✅ Step③ UI (no business logic change)
  const statusLabel = canComplete ? "入力済み" : "未完了";
  

  // ✅ Only validate formats (do NOT block temporary save)
    const validateFormatOnly = () => {
    for (let i = 0; i < data.store_items.length; i += 1) {
      const item = data.store_items[i];
      if (item.email.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(item.email.trim())) {
        return `店舗${i + 1}のEmailの形式が正しくありません。`;
      }
    }
    return "";
  };

  const onPickFile = () => {
    fileRef.current?.click();
  };

  const onFileSelected = (f: File | null) => {
    setSuccess("");
    setError("");

    if (!f) {
      setData((prev) => ({ ...prev, store_list_file_selected: null }));
      return;
    }

    const ext = (f.name.split(".").pop() || "").toLowerCase();
    const ok = ["pdf", "xls", "xlsx", "csv"].includes(ext);
    if (!ok) {
      setError("アップロードできる形式は PDF / Excel（.xls/.xlsx）/ CSV です。");
      setData((prev) => ({ ...prev, store_list_file_selected: null }));
      return;
    }

    setData((prev) => ({ ...prev, store_list_file_selected: f }));
  };
  









    const syncTopLevelFromItems = (items: StoreItem[]) => {
    const first = items[0] || emptyStoreItem();
    return {
      store_name: first.store_name,
      store_name_kana: first.store_name_kana,
      store_postal: first.store_postal,
      store_city: first.store_city,
      store_address: first.store_address,
      phone: first.phone,
      fax: first.fax,
      email: first.email,
    };
  };

  const updateStoreItem = (index: number, patch: Partial<StoreItem>) => {
    setData((prev) => {
      const nextItems = prev.store_items.map((item, idx) =>
        idx === index ? { ...item, ...patch } : item
      );
      return {
        ...prev,
        ...syncTopLevelFromItems(nextItems),
        store_items: nextItems,
      };
    });
  };

  const addStoreItem = () => {
    setData((prev) => {
      const nextItems = [...prev.store_items, emptyStoreItem()];
      return {
        ...prev,
        ...syncTopLevelFromItems(nextItems),
        store_items: nextItems,
      };
    });
  };

  const removeStoreItem = (index: number) => {
    setData((prev) => {
      if (prev.store_items.length <= 1) return prev;
      const nextItems = prev.store_items.filter((_, idx) => idx !== index);
      return {
        ...prev,
        ...syncTopLevelFromItems(nextItems),
        store_items: nextItems,
      };
    });
  };










  const onClearSelectedFile = () => {
    setData((prev) => ({ ...prev, store_list_file_selected: null }));
    if (fileRef.current) fileRef.current.value = "";
  };

    const onSave = async (): Promise<boolean> => {
    setSuccess("");
    setError("");

    const msg = validateFormatOnly();
    if (msg) {
      setError(msg);
      return false;
    }

    setSaving(true);

    try {
      const form = new FormData();

      if (data.store_list_file_selected) {
        form.append("store_list_file", data.store_list_file_selected);
      }

      const first = data.store_items[0] || emptyStoreItem();

      form.append("store_name", first.store_name);
      form.append("store_name_kana", first.store_name_kana);

      form.append("store_postal", first.store_postal);
      form.append("store_city", first.store_city);
      form.append("store_address", first.store_address);

      form.append("phone", first.phone);
      form.append("fax", first.fax);
      form.append("email", first.email);

      form.append("store_items_json", JSON.stringify(data.store_items));

      form.append("is_completed", String(canComplete));

      const json = await apiPut("/merchant/forms/store-list", form);

      setData((prev) => ({
        ...prev,
        ...syncTopLevelFromItems(prev.store_items),
        is_completed: canComplete,
        store_list_file_selected: null,
      }));
      if (fileRef.current) fileRef.current.value = "";

      const okCompleted = Boolean(json?.is_completed ?? canComplete);
      setSuccess(okCompleted ? "保存しました（入力済み）" : "保存しました（未完了）");
      setSaving(false);
      return true;
    } catch (e: any) {
      setError(
        e?.message ||
          "保存に失敗しました。バックエンドが起動しているか、Form6のAPIが実装済みか確認してください。"
      );
      setSaving(false);
      return false;
    }
  };

    const onBack = async () => {
    const ok = await onSave();
    if (!ok) return;
    navigate("/merchant/forms/sales-method");
  };

  const onNext = async () => {
    const ok = await onSave();
    if (!ok) return;
    navigate("/merchant/forms/contact-person");
  };

  const onList = async () => {
  const ok = await onSave();
  if (!ok) return;
  navigate("/merchant/register");
};


    



  // ✅ required labels turn red ONLY when upload is not present
  const req = (label: string) => ({ label, required: !hasUploadedFile });

  return (
    <MerchantLayout title="6. 店舗一覧" active="forms">
      {loading && <div style={{ color: "#475569" }}>読み込み中...</div>}

      {error && (
        <div
          style={{
            marginBottom: 12,
            background: "#fff1f2",
            border: "1px solid #fecdd3",
            color: "#b91c1c",
            padding: "10px 12px",
            borderRadius: 12,
            fontWeight: 800,
          }}
        >
          {error}
        </div>
      )}

      {success && (
        <div
          style={{
            marginBottom: 12,
            background: "#ecfdf5",
            border: "1px solid #bbf7d0",
            color: "#166534",
            padding: "10px 12px",
            borderRadius: 12,
            fontWeight: 900,
          }}
        >
          {success}（いつでも編集できます）
        </div>
      )}

      {!loading && (
        <>
          {/* Upload section */}
          <div
            style={{
              border: "1px solid #cbd5e1",
              borderRadius: 12,
              overflow: "hidden",
              background: "#fff",
              marginBottom: 14,
            }}
          >
            <div
              style={{
                padding: "10px 12px",
                fontWeight: 900,
                background: "#f8fafc",
                borderBottom: "1px solid #e2e8f0",
              }}
            >
              店舗一覧別紙添付（PDF / Excel）
            </div>

            <div style={{ padding: 12 }}>
              <div style={{ color: "#475569", fontWeight: 800, marginBottom: 10 }}>
                ※ 店舗名・フリガナ・Email の記載があるもの（推奨）
                <br />
                
              </div>

              <input
                ref={fileRef}
                type="file"
                accept=".pdf,.xls,.xlsx,.csv"
                style={{ display: "none" }}
                onChange={(e) => onFileSelected(e.target.files?.[0] || null)}
              />

              <div
                style={{
                  display: "flex",
                  gap: 10,
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <button
                  onClick={onPickFile}
                  style={{
                    padding: "10px 14px",
                    borderRadius: 10,
                    border: "1px solid #cbd5e1",
                    background: "#fff",
                    color: "#0f172a",
                    fontWeight: 900,
                    cursor: "pointer",
                  }}
                >
                  ファイルを選択
                </button>

                {data.store_list_file_selected && (
                  <div style={{ fontWeight: 900, color: "#0f172a" }}>
                    選択中：{data.store_list_file_selected.name}
                    <button
                      onClick={onClearSelectedFile}
                      style={{
                        marginLeft: 10,
                        padding: "6px 10px",
                        borderRadius: 10,
                        border: "1px solid #fecdd3",
                        background: "#fff1f2",
                        color: "#b91c1c",
                        fontWeight: 900,
                        cursor: "pointer",
                      }}
                    >
                      取消
                    </button>
                  </div>
                )}

                {!data.store_list_file_selected && data.store_list_file_name && (
                  <div style={{ fontWeight: 900, color: "#0f172a" }}>
                    登録済みファイル：{data.store_list_file_name}
                  </div>
                )}
              </div>

              
              
            </div>
          </div>

          {/* Manual section */}
          <div
            style={{
              border: "1px solid #cbd5e1",
              borderRadius: 12,
              overflow: "hidden",
              background: "#fff",
            }}
          >
            <div
              style={{
                padding: "10px 12px",
                fontWeight: 900,
                background: "#f8fafc",
                borderBottom: "1px solid #e2e8f0",
              }}
            >
              店舗情報（アップロードがない場合は必須）
            </div>

            <div style={{ padding: 12 }}>
                            {data.store_items.map((item, index) => (
                <div
                  key={index}
                  style={{
                    border: "1px solid #e2e8f0",
                    borderRadius: 12,
                    padding: 12,
                    marginBottom: 14,
                    background: index === 0 ? "#ffffff" : "#f8fafc",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: 12,
                      marginBottom: 12,
                    }}
                  >
                    <div style={{ fontWeight: 900, color: "#0f172a" }}>
                      店舗情報 {index + 1}
                    </div>

                    {index > 0 && (
                      <button
                        type="button"
                        onClick={() => removeStoreItem(index)}
                        style={{
                          padding: "8px 12px",
                          borderRadius: 10,
                          border: "1px solid #fecdd3",
                          background: "#fff1f2",
                          color: "#b91c1c",
                          fontWeight: 900,
                          cursor: "pointer",
                        }}
                      >
                        削除
                      </button>
                    )}
                  </div>

                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "minmax(0,1fr) minmax(0,1fr)",
                      gap: 20,
                      alignItems: "start",
                    }}
                  >
                    <Field {...req("店舗名（全角）")}>
                      <input
                        value={item.store_name}
                        placeholder="例）〇〇店（全角50字まで）"
                        onChange={(e) => updateStoreItem(index, { store_name: e.target.value })}
                        style={inputStyle}
                      />
                    </Field>

                    <Field {...req("店舗名フリガナ（半角）")}>
                      <input
                        value={item.store_name_kana}
                        placeholder="例）○○ﾃﾝ（半角50字まで）"
                        onChange={(e) =>
                          updateStoreItem(index, { store_name_kana: e.target.value })
                        }
                        style={inputStyle}
                      />
                    </Field>

                    <Field {...req("店舗所在地 郵便番号")}>
                      <input
                        value={item.store_postal}
                        placeholder="半角数字"
                        onChange={async (e) => {
                          const value = e.target.value.replace(/\D/g, "").slice(0, 7);

                          updateStoreItem(index, { store_postal: value });

                          if (value.length === 7) {
                            try {
                              const res = await fetch(`${API_BASE}/postal/${value}`);
                              const json = await res.json();

                              if (json?.ok && json?.data) {
                                updateStoreItem(index, {
                                  store_postal: value,
                                  store_city: json.data.address_city || "",
                                  store_address: json.data.address_rest || "",
                                });
                              }
                            } catch (err) {
                              console.error("Postal lookup failed", err);
                            }
                          }
                        }}
                        style={inputStyle}
                      />
                    </Field>

                    <Field {...req("店舗所在地 ～市町村丁目（全角）")}>
                      <input
                        value={item.store_city}
                        placeholder="例）東京都渋谷区（全角・郵便番号から自動反映）"
                        onChange={(e) => updateStoreItem(index, { store_city: e.target.value })}
                        style={inputStyle}
                      />
                    </Field>

                    <Field {...req("店舗所在地 番地以降（全角）")}>
                      <input
                        value={item.store_address}
                        placeholder="例）〇〇1-2-3 〇〇ビル2F（全角50字まで）"
                        onChange={(e) =>
                          updateStoreItem(index, { store_address: e.target.value })
                        }
                        style={inputStyle}
                      />
                    </Field>

                    <Field {...req("電話番号")}>
                      <input
                        value={item.phone}
                        placeholder="例）03-1234-5678"
                        onChange={(e) =>
                          updateStoreItem(index, {
                            phone: formatPhoneNumber(e.target.value),
                          })
                        }
                        style={inputStyle}
                      />
                    </Field>

                    <Field label="FAX番号">
                      <input
                        value={item.fax}
                        placeholder="例）03-1234-5679"
                        onChange={(e) =>
                          updateStoreItem(index, {
                            fax: formatPhoneNumber(e.target.value),
                          })
                        }
                        style={inputStyle}
                      />
                    </Field>

                    <Field {...req("Email")}>
                      <input
                        value={item.email}
                        placeholder="例）info@example.com"
                        onChange={(e) => updateStoreItem(index, { email: e.target.value })}
                        style={inputStyle}
                      />
                    </Field>
                  </div>
                </div>
              ))}

              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <button
                  type="button"
                  onClick={addStoreItem}
                  style={{
                    padding: "10px 14px",
                    borderRadius: 10,
                    border: "1px solid #1d4ed8",
                    background: "#eff6ff",
                    color: "#1d4ed8",
                    fontWeight: 900,
                    cursor: "pointer",
                  }}
                >
                  ＋ 店舗を追加
                </button>
              </div>

              <div style={{ marginTop: 8, color: "#475569", fontWeight: 800, fontSize: 12 }}>
                ※ アップロードがある場合は手入力不要ですが、必要に応じて入力しても問題ありません。
              </div>
            </div>
          </div>

          {/* ✅ Step③: only ONE button + status */}
                    <div
            style={{
              marginTop: 18,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 12,
            }}
          >
            <button
              onClick={onBack}
              disabled={saving}
              style={{
                padding: "12px 16px",
                borderRadius: 12,
                border: "none",
                background: "#dc2626",
                color: "#fff",
                fontWeight: 900,
                cursor: saving ? "not-allowed" : "pointer",
                opacity: saving ? 0.7 : 1,
                transition: "background 0.2s ease",
              }}
            >
              {saving ? "保存中..." : "戻る"}
            </button>

            <button
              onClick={onSave}
              disabled={saving}
              style={{
                padding: "12px 16px",
                borderRadius: 12,
                border: "none",
                background: "#1d4ed8",
                color: "#fff",
                fontWeight: 900,
                cursor: saving ? "not-allowed" : "pointer",
                opacity: saving ? 0.7 : 1,
                transition: "background 0.2s ease",
              }}
            >
              {saving ? "保存中..." : "保存"}
            </button>

            <button
  onClick={onList}
  disabled={saving}
  style={{
    padding: "12px 16px",
    borderRadius: 12,
    border: "none",
    background: "#64748b",
    color: "#fff",
    fontWeight: 900,
    cursor: saving ? "not-allowed" : "pointer",
    opacity: saving ? 0.7 : 1,
    transition: "background 0.2s ease",
  }}
>
  一覧
</button>

            <button
              onClick={onNext}
              disabled={saving}
              style={{
                padding: "12px 16px",
                borderRadius: 12,
                border: "none",
                background: "#dc2626",
                color: "#fff",
                fontWeight: 900,
                cursor: saving ? "not-allowed" : "pointer",
                opacity: saving ? 0.7 : 1,
                transition: "background 0.2s ease",
              }}
            >
              {saving ? "保存中..." : "次へ"}
            </button>
          </div>

          <div style={{ marginTop: 10, fontSize: 13, color: "#475569" }}>
            ステータス：{" "}
            <span style={{ fontWeight: 900, color: canComplete ? "#dc2626" : "#64748b" }}>
              {statusLabel}
            </span>
          </div>

          {!canComplete && (
            <div style={{ fontSize: 12, color: "#475569", fontWeight: 800 }}>
              ※ 必須項目が未入力のため「未完了」になります
            </div>
          )}
        </>
      )}
    </MerchantLayout>
  );
}

function Field({
  label,
  required,
  children,
}: {
  label: string;
  required?: boolean;
  children: React.ReactNode;
}) {
  return (
    <div style={{ minWidth: 0 }}>
      <div style={{ fontSize: 13, fontWeight: 900, marginBottom: 6, color: "#0f172a" }}>
        {label} {required ? <span style={{ color: "#b91c1c" }}>（必須）</span> : null}
      </div>
      {children}
    </div>
  );
}

const inputStyle: React.CSSProperties = {
  width: "100%",
  height: 44,
  padding: "0 12px",
  borderRadius: 10,
  border: "1px solid #cbd5e1",
  background: "#fff",
  color: "#0f172a",
  fontSize: 14,
  outline: "none",
  boxSizing: "border-box",
};
